// 订单菜单接口
import axios from 'axios'

// 小程序订单微信退款
export function orderRefund(data) {
  return axios({
    url: `/api/weChat/refund`,
    method: 'post',
    data
  })
}

// 微信预支付接口——补款操作
export function orderPrepay(data) {
  return axios({
    url: `/api/weChat/prepay`,
    method: 'post',
    data
  })
}

// 订单列表(分页)
export function getOrder(data) {
  return axios({
    url: `/api/oms/order/listPage`,
    method: 'get',
    params: data
  })
}
// 订单列表查询(不分页)
export function getOrderAll(data) {
  return axios({
    url: `/api/oms/order/list`,
    method: 'get',
    params: data
  })
}
// 通过订单号查询订单
export function getOrderSn(orderSn) {
  return axios({
    url: `/api/oms/order/orderByOrderSn?orderSn=${orderSn}`,
    method: 'get'
  })
}
// 通过寄回订单号查询订单
export function getBackOrderSn(backOrderSn) {
  return axios({
    url: `/api/oms/order/orderByBackOrderSn?backOrderSn=${backOrderSn}`,
    method: 'get'
  })
}
// 订单新增
export function addOrder(data) {
  return axios({
    url: `/api/oms/order/insert`,
    method: 'post',
    data
  })
}
// 订单返洗接口
export function insertBackOrder(data) {
  return axios({
    url: `/api/oms/order/insertBack`,
    method: 'post',
    data
  })
}
// 订单删除
export function deleteOrder(id) {
  return axios({
    url: `/api/oms/order/delete?id=${id}`,
    method: 'get'
  })
}
// 订单修改
export function updateOrder(data) {
  return axios({
    url: `/api/oms/order/update`,
    method: 'post',
    data
  })
}
// 订单出厂
export function orderExFactory(data) {
  return axios({
    url: `/api/oms/order/orderExFactory`,
    method: 'post',
    data
  })
}
// 通过订单号修改衣物子项为已出厂
export function exFactoryOrderSn(orderSn) {
  return axios({
    url: `/api/oms/order/exFactoryByOrderSn?orderSn=${orderSn}`,
    method: 'get'
  })
}
// 订单修改预约时间
// export function updateBeginTime(data) {
//   return axios({
//     url: `/api/oms/order/updateBeginTime`,
//     method: 'post',
//     data
//   })
// }
// 订单修改寄回地址
// export function updateReceiver(data) {
//   return axios({
//     url: `/api/oms/order/updateReceiver`,
//     method: 'post',
//     data
//   })
// }
//通过订单号获取寄出物流轨迹 ↓↓一样的
export function expressDetail(orderSn) {
  return axios({
    url: `/api/oms/order/expressByOrderSn?orderSn=${orderSn}`,
    method: 'get'
  })
}

// 通过订单号获取寄出物流状态
export function expressStatus(orderSn) {
  return axios({
    url: `/api/oms/order/expressOrderByOrderSn?orderSn=${orderSn}`,
    method: 'get'
  })
}
//通过订单号获取寄回物流轨迹 ↓↓一样的
export function expressBackDetail(backOrderSn) {
  return axios({
    url: `/api/oms/order/expressByBackOrderSn?backOrderSn=${backOrderSn}`,
    method: 'get'
  })
}

// 通过订单号获取寄回物流状态
export function expressBackStatus(backOrderSn) {
  return axios({
    url: `/api/oms/order/expressOrderByBackOrderSn?backOrderSn=${backOrderSn}`,
    method: 'get'
  })
}
// 扫描枪扫描寄出物流子母单号获取订单
export function orderByDeliverySn(deliverySn) {
  return axios({
    url: `/api/oms/order/orderByDeliverySn?deliverySn=${deliverySn}`,
    method: 'get'
  })
}
// 通过订单号获取订单子项
export function orderItem(orderSn) {
  return axios({
    url: `/api/oms/order/orderItem?orderSn=${orderSn}`,
    method: 'get'
  })
}
// 通过订单号获取商品信息
export function orderProduct(paySn) {
  return axios({
    url: `/api/oms/order/orderProduct?paySn=${paySn}`,
    method: 'get'
  })
}
// 通过订单ID查询订单
export function orderSelectById(id) {
  return axios({
    url: `/api/oms/order/selectById?id=${id}`,
    method: 'get'
  })
}
// 通过订单号获取工单
export function orderWorkBy(orderSn) {
  return axios({
    url: `/api/oms/order/workByOrderSn?orderSn=${orderSn}`,
    method: 'get'
  })
}

// 订单附件删除
export function annexDelete(id) {
  return axios({
    url: `/api/oms/orderItemDetail/delete?id=${id}`,
    method: 'get'
  })
}
// 订单附件新增
export function annexInsert(data) {
  return axios({
    url: `/api/oms/orderItemDetail/insert`,
    method: 'post',
    data
  })
}
// 通过订单子项id查询订单附件
export function annexListFj(orderItemId) {
  return axios({
    url: `/api/oms/orderItemDetail/listByOrderItemId?orderItemId=${orderItemId}`,
    method: 'get'
  })
}
// 通过订单编号查询订单附件
export function annexOrderSn(orderSn) {
  return axios({
    url: `/api/oms/orderItemDetail/listByOrderSn?orderSn=${orderSn}`,
    method: 'get'
  })
}
// 订单附件未总检接口返回的是数量
export function listCount(orderItemId) {
  return axios({
    url: `/api/oms/orderItemDetail/listByCount?orderItemId=${orderItemId}`,
    method: 'get'
  })
}
// 订单附件修改
export function annexUpdate(data) {
  return axios({
    url: `/api/oms/orderItemDetail/update`,
    method: 'post',
    data
  })
}
// 美团提前完结订单
export function advanceOrder(data) {
  return axios({
    url: `/api/oms/order/advanceOrder`,
    method: 'post',
    data
  })
}

// 工单列表(分页)
export function getOrderWork(data) {
  return axios({
    url: `/api/oms/orderWork/listPage`,
    method: 'get',
    params: data
  })
}
// 工单查询列表(不分页)
export function getOrderWorkAll(data) {
  return axios({
    url: `/api/oms/orderWork/list`,
    method: 'get',
    params: data
  })
}
// 删除工单
export function deleteOrderWork(id) {
  return axios({
    url: `/api/oms/orderWork/delete?id=${id}`,
    method: 'get'
  })
}
// 新增工单
export function insertOrderWork(data) {
  return axios({
    url: `/api/oms/orderWork/insert`,
    method: 'post',
    data
  })
}
// 修改工单
export function updateOrderWork(data) {
  return axios({
    url: `/api/oms/orderWork/update`,
    method: 'post',
    data
  })
}
// 工单导出
export function getOrderWordDown(data) {
  return axios({
    url: `/api/oms/orderWork/downLoadData`,
    method: 'get',
    responseType: "blob",
    params: data
  })
}
// 工单列举图片
// ossFolderName
export function listFileWork(ossFolderName) {
  return axios({
    url: `/api/oms/orderWork/listFile?ossFolderName=${ossFolderName}`,
    method: 'get'
  })
}
// get工单上传图片
// file,ossFolderName
export function uploadFileWork(data) {
  return axios({
    url: `/api/oms/orderWork/uploadFile`,
    method: 'get',
    params: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
// post工单上传图片
export function uploadFilesWork(data) {
  return axios({
    url: `/api/oms/orderWork/uploadFile`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
// post工单图片删除 filePath
export function deleteFilesWork(data) {
  return axios({
    url: `/api/oms/orderWork/deleteFile`,
    method: 'post',
    params: data
  })
}
// get工单图片删除filePath
export function deleteFileWork(data) {
  return axios({
    url: `/api/oms/orderWork/deleteFile`,
    method: 'get',
    params: data
  })
}

//工厂地址列表(分页)
export function getFactoryAddr(data) {
  return axios({
    url: `/api/oms/factoryAddr/listPage`,
    method: 'get',
    params: data
  })
}
//工厂地址查询(不分页)
export function getFactoryAll(data) {
  return axios({
    url: `/api/oms/factoryAddr/list`,
    method: 'get',
    params: data
  })
}
//新增工厂地址
export function insertFactoryAddr(data) {
  return axios({
    url: `/api/oms/factoryAddr/insert`,
    method: 'post',
    data
  })
}
//删除工厂地址
export function deleteFactoryAddr(id) {
  return axios({
    url: `/api/oms/factoryAddr/delete?id=${id}`,
    method: 'get',
  })
}
//修改工厂地址
export function updateFactoryAddr(data) {
  return axios({
    url: `/api/oms/factoryAddr/update`,
    method: 'post',
    data
  })
}



